module.exports = function isNil(x) {
  return x === null || x === void 0;
};


//////////////////
// WEBPACK FOOTER
// /produit/nodejs/bin/node-v14.19.0-linux-x64/lib/~/tcomb/lib/isNil.js
// module id = 58
// module chunks = 0